import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as translator from '../../../../utils/translator';
import { clientConfig } from '../../../../config';
import './OrderActionBanner.css';

const warningIcon = `${clientConfig.IMAGES_URL}uploads/icons/thankyou-warning.svg`;

interface Props {
  hashID: string;
  country: string;
  language: string;
  needsPhotoUpload?: boolean;
  needsIdVerification?: boolean;
  idVerificationInProgress?: boolean;
  needsDoseProof?: boolean;
}

const OrderActionBanner: React.FC<Props> = ({ hashID, country, language, needsPhotoUpload, needsIdVerification, idVerificationInProgress, needsDoseProof }) => {
  const navigate = useNavigate();

  if (!needsPhotoUpload && !needsIdVerification && !idVerificationInProgress && !needsDoseProof) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/${country}/account/my-orders/${hashID}/details`);
  };

  // HL-12997: an open proof of previous use keeps the "documents missing" banner.
  if (idVerificationInProgress && !needsIdVerification && !needsDoseProof) {
    return (
      <div className="order-action-banner order-action-banner--pending">
        <div className="order-action-banner__content">
          <div className="order-action-banner__icon-wrap">
            <img src={warningIcon} alt="" className="order-action-banner__icon" />
          </div>
          <div>
            <span className="order-action-banner__badge">{translator.translate(language, 'my_account', 'OrderActionBanner/badge_pending')}</span>
            <p className="order-action-banner__text">{translator.translate(language, 'my_account', 'OrderActionBanner/message_pending')}</p>
          </div>
        </div>
        <button className="order-action-banner__btn" onClick={handleClick}>
          {translator.translate(language, 'my_account', 'OrderActionBanner/button')}
        </button>
      </div>
    );
  }

  const openDocuments = [needsPhotoUpload, needsIdVerification, needsDoseProof].filter(Boolean).length;
  const message = translator.translate(
    language,
    'my_account',
    openDocuments >= 3 ? 'OrderActionBanner/message_three' : openDocuments === 2 ? 'OrderActionBanner/message_two' : 'OrderActionBanner/message_one'
  );

  return (
    <div className="order-action-banner">
      <div className="order-action-banner__content">
        <div className="order-action-banner__icon-wrap">
          <img src={warningIcon} alt="" className="order-action-banner__icon" />
        </div>
        <p className="order-action-banner__text">{message}</p>
      </div>
      <button className="order-action-banner__btn" onClick={handleClick}>
        {translator.translate(language, 'my_account', 'OrderActionBanner/button')}
      </button>
    </div>
  );
};

export default OrderActionBanner;
